import Vue from "vue";
import Vuex from "vuex";
import LogRocket from "logrocket";
// import createPlugin from "logrocket-vuex";
import { NS_USER } from "@/store/constants";
import user from "@/store/user/index";

Vue.use(Vuex);

// const logrocketPlugin = createPlugin(LogRocket);
export const store = new Vuex.Store({
  modules: {
    [NS_USER]: user
  }
  // plugins: [logrocketPlugin]
});
